module.exports = __webpack_public_path__ + "static/media/food-line-4.7c19801e.jpg";